export default __webpack_public_path__ + "static/media/data-home-pic2.1784c12c.png";